import React from 'react';
import './studio.css';
import { useTranslation } from '../../hooks/translation';

interface StudioProps {
  lang: string;
}

export const Studio: React.FC<StudioProps> = ({ lang }) => {
  const { t } = useTranslation(lang);

  return (
    <section id="studio" className="section">
      <hr />
      <div className="container">
        <h1>{t('studio.title')}</h1>
        <p>
          <b>{t('studio.intro.bold')}</b> {t('studio.intro.rest')}
        </p>
        <p>{t('studio.body.1')}</p>
        <p>{t('studio.body.2')}</p>
        <p>{t('studio.body.3')}</p>
        <p>{t('studio.body.4')}</p>
        <p>
          {t('studio.closing.start')} <a href="#contact" title="Contact LIFTER Studio">{t('studio.closing.bold')}</a>.
        </p>
        <br />
      </div>
    </section>
  );
};
